import { confirmationModalShow } from 'Global/Stores/modals'

const confirmationMiddleware = ({ dispatch, getState }) => next => action => {
  if (!action.payload || !action.payload.confirmationMessage) {
    return next(action)
  }

  const { payload, meta, type } = action

  const nextAction = confirmationModalShow(payload.confirmationMessage, {
    meta,
    type,
  })

  return next(nextAction)
}

export default confirmationMiddleware
